import Vue from 'vue'
import Vuex from 'vuex'
import pkg from 'package'
import * as actions from './actions'
import * as getters from './getters'
import app from './modules/app'
import menu from './modules/menu'
import * as types from './mutation-types'

Vue.use(Vuex)

const PROJECT_TYPES = ['basic', 'private', 'business']

function initProjectsCountByType() {
  let counts = {}
  PROJECT_TYPES.forEach(type => {
    counts[type] = 0
  })
  return counts
}

const store = new Vuex.Store({
  strict: true,  // process.env.NODE_ENV !== 'production',
  actions,
  getters,
  modules: {
    app,
    menu
  },
  state: {
    pkg,
    user: '',
    subscription: '',
    planPrices: {},
    projectTypes: PROJECT_TYPES,
    projectsCount: initProjectsCountByType()
  },
  mutations: {
    [types.SET_USER] (state, user) {
      state.user = user
    },
    [types.SET_PROJECTS_COUNT] (state, data) {
      state.projectsCount[data.type] = data.count
    },
    [types.SET_SUBSCRIPTION] (state, subscription) {
      state.subscription = subscription
    },
    [types.SET_PLAN_PRICES] (state, planPrices) {
      state.planPrices = planPrices
    }
  }
})

export default store
